import { FC } from 'react';
import { Client } from 'styletron-engine-atomic';
import { Provider } from 'styletron-react';

const engine = new Client();

export const StyletronProvider: FC = ({ children }) => (
  <Provider value={engine}>{children}</Provider>
);
